import React, { useCallback, useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import "dayjs/locale/en-gb";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";

import dayjs from "dayjs";

import EncryptService from "../../service/EncryptionService";

import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";

import { Button } from "@mui/material";

function EditMaterialData() {
  const { state } = useLocation();
  const navigate = useNavigate();
 
  const [poNumber, setpoNumber] = useState("");

 const [poValue, setpoValue] = useState("");
  const [poQuantity, setpoQuantity] = useState("");

  const [billrecDate, setBillRecDate] = useState(null);
  const [getpassnumber, setGetPassNumber] = useState(null);
  const [oldgetpassnumber, setOldGetPassNumber] = useState(null);

  const [formData, setFormData] = useState({
    poNumber: "",
    poValue: "",
    poQuantity: "",
   
  });
  // Update form field values
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === "poQuantity" || field === "poValue") {
      validateField(field, value);
    }
  };
  const [indentConsigneeName, setindentConsigneeName] = useState("");
  const validateField = (field, value) => {
    let error = "";
    if (field === "poQuantity" || field === "poValue") {
      if (!value || isNaN(value) || value <= 0) {
        error = `${field} should be more than zero`;
      }
    }
    setErrors((prev) => ({ ...prev, [field]: error }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.poNumber) newErrors.poNumber = "PO Number is required";
       if (
      !formData.poQuantity ||
      isNaN(formData.poQuantity) ||
      formData.poQuantity <= 0
    ) {
      newErrors.poQuantity = "Quantity should be more than zero";
    }
    if (!formData.poValue || isNaN(formData.poValue) || formData.poValue <= 0) {
      newErrors.poValue = "Value should be more than zero";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 

  const [minCalDate, setMinCalDate] = useState(dayjs());

  const today = dayjs();
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));


  const handleQuantityChange = (value) => {
    setpoQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };
 
  const handleValueChange = (value) => {
    setpoValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };


  const updatePOData = async () => {
    
    let formErrors = {};

   

    if (
      !poQuantity ||
      poQuantity.length === 0 ||
      isNaN(parseFloat(poQuantity)) ||
      parseFloat(poQuantity) <= 0
    ) {
      formErrors.qty = "Qty should be more than zero";
    }

    if (!poValue || isNaN(parseFloat(poValue)) || parseFloat(poValue) <= 0) {
      formErrors.val = "Value should be more than zero";
    }

    if (!poNumber || poNumber.length === 0) {
      formErrors.po = "PO Number Should not be Blank";
    }

    if (!getpassnumber || getpassnumber.length === 0) {
      formErrors.getpass = "New Gate Pass Number Should not be Blank";
    }
    
   
    setErrors(formErrors);

   // console.log(formErrors);
    if (Object.keys(formErrors).length === 0) {
      // const podt = new Date(poDate);
      // const ponewdate =
      //   podt.getFullYear() +
      //   "/" +
      //   parseInt(podt.getMonth() + 1) +
      //   "/" +
      //   podt.getDate();

      const billdt = new Date(billrecDate);
      const Bill_date =
      billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

          

      apiClient
        .post("/receiveditemdataupdate", {
       
         oldgetpassnumber,
         newgetpassnumber:getpassnumber,
          poNumber,
          recDate:Bill_date,
          poQuantity,
          poValue,
          uname,
         ip,
        
        })
        .then(function (response) {
         // console.log(response.data);
          resetData();
          //navigate("../polist", { replace: true });
        })
        .catch(function (error) {
          
            alert(error.response.data.code);
         
        });
    }
  };

  const getPOdata = async () => {
    try {
      const response = await apiClient.post("/getReceivedItembyPONumberGetPassNumber", {
        ponumber: poNumber,
        getpassnumber:oldgetpassnumber,
        uname: uname,
      });

      if (response.status === 201 && response.data?.length > 0) {
        const poData = response.data[0]; // Use directly

        setpoQuantity(poData.ItemQuantity || "");
        setpoValue(poData.ItemValue || "");
        setBillRecDate(dayjs(poData.itemReceivedDate || null));
        setGetPassNumber(poData.getpassnumber || "");

      } else {
        alert("Invalid PO Number");
      }
    } catch (error) {
    //  console.error("Error fetching PO data:", err);
      //alert("Check Entered Data and try again.");
       const errorMsg = error?.response?.data?.message || error.message || "Unknown error occurred";
       alert("Error fetching data: " + errorMsg);
      resetData();
    }
  };

 

  const resetData = async () => {
  
    setpoNumber(null);
    setOldGetPassNumber(null)
    setpoQuantity(null);
    setpoValue(null);
    setBillRecDate(null);
    setGetPassNumber(null);
    



  };

    const handleChange = (event) => {
    const inputValue = event.target.value.toUpperCase();
    // Remove any non-alphanumeric characters
    const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");
    setpoNumber(alphanumericValue);
  };

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
    <div className="row">
      <div>
        <div className="p-2">
          <div className="container">
            <div className="input-group">
              <CustomTextField
                label="PO Number (Max 20 Character)*"
                value={poNumber || ""}
                onChange={handleChange}
                placeholder="PO Number (Max 20 Character)*"
                maxLength={20} // Set the maximum length
                //multiline={false} // Enable multiline
                error={!!errors.po}
                helperText={errors.po}
              />
            </div>
            <div className="input-group">
             <CustomTextField
                               label="Old Gate Entry Pass Number/ Memo Number/ Invoice Number"
                               value={oldgetpassnumber ?? ""}
                               onChange={(e) => {
                                 setOldGetPassNumber(e.target.value);
                               }}
                               placeholder="Old Entry Pass Number/ Memo Number/ Invoice Number"
                               maxLength={50} // Set the maximum length
                               //error={!!errors.getpass}
                              // helperText={errors.getpass}
                             />
            </div>
            <div className="input-group">
            <Button
  variant="contained"
  color="primary"
  startIcon={<SearchIcon />}
  onClick={getPOdata}
  disabled={!(oldgetpassnumber && poNumber)} // Button is disabled until both values are present
>
  Search
</Button>
            </div>
          </div>

          <div className="container mt-4">
                    
            <div className="input-group">
              <NumericTextField
                id="ItemQuantity"
                label="Item Quantity"
                title="Item Quantity"
                error={errors.qty}
                value={poQuantity || ""}
                onChange={handleQuantityChange}
                //disabled={true}
              />
            </div>
            
            <div className="input-group">
              <NumericTextField
                id="ItemValue"
                label="Item Value"
                title="Item Value"
                error={errors.val}
                value={poValue || ""}
                onChange={handleValueChange}
               // disabled={true}
              />
            </div>
        
           
          </div>

       
          <div className="container">
          <div className="input-group mt-2">
          <CustomTextField
                               label="New Gate Entry Pass Number/ Memo Number/ Invoice Number"
                               value={getpassnumber ?? ""}
                               onChange={(e) => {
                                 setGetPassNumber(e.target.value);
                               }}
                               placeholder="New Entry Pass Number/ Memo Number/ Invoice Number"
                               maxLength={50} // Set the maximum length
                               error={!!errors.getpass}
                               helperText={errors.getpass}
                             />
            </div>

            <div className="input-group">
              <DatePickerComponent
                label="Item Receiving Date"
                id="itemreceivingdate"
                value={billrecDate}
                onChange={(newDate) => handleDateChange(newDate, setBillRecDate)} // Pass setPoDate
               // error={errors.errDPDate} // Display error
               // minDate={dayjs(poDate) ?? minCalDate}
               // disabled={true}
              />
            </div>

</div>



        </div>
      </div>

      <div className="container mt-4"></div>
      <div
        className="flex container"
        style={{
          display: "flex",
          paddingLeft: "40px",
          paddingRight: "40px",
          justifyContent: "space-between", // Distributes space between items
        }}
      >
        <button
          className="button button1"
          type="button" // Updated type attribute to "button"
          onClick={updatePOData}
          title="Click for Update Data"
          disabled={!getpassnumber}
        >
          Update Data
        </button>

        
      </div>
    </div>
  );
}


export default EditMaterialData